import { render, staticRenderFns } from "./OtorrinoSintomas.vue?vue&type=template&id=7562630a"
import script from "./OtorrinoSintomas.vue?vue&type=script&lang=js"
export * from "./OtorrinoSintomas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports